import { render, staticRenderFns } from "./MyEndpointPage.vue?vue&type=template&id=180935f3"
import script from "./MyEndpointPage.vue?vue&type=script&lang=js"
export * from "./MyEndpointPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports